<template>
  <div>
    <label v-if="label" class="block text-gray-400 mb-2" :for="id">{{ label }}:</label>
    <vue-editor :id="id" v-model="content" :editorToolbar="toolbar" @input="$emit('input', content)"></vue-editor>
    <div v-if="errors.length" class="text-red-500 text-sm mt-2">{{ errors[0] }}</div>
  </div>
</template>

<script>
  import {VueEditor} from "vue2-editor";

  export default {
    inheritAttrs: false,
    components: {VueEditor},
    props: {
      id: {
        type: String,
        default() {
          return `editor-${this._uid}`
        },
      },
      value: null,
      label: String,
      errors: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        content: this.value,
        toolbar: [
          [{header: [false, 1, 2, 3, 4, 5, 6]}],
          ["bold", "italic", "underline", "strike"], // toggled buttons
          [
            {align: ""},
            {align: "center"},
            {align: "right"},
            {align: "justify"}
          ],
          ["blockquote", "code-block"],
          [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
          [{indent: "-1"}, {indent: "+1"}], // outdent/indent
          [{color: []}, {background: []}], // dropdown with defaults from theme
          ["link"],
        ]
      }
    },
    methods: {},
  }
</script>
